import { render, staticRenderFns } from "./couponSlide.vue?vue&type=template&id=42f780c8&scoped=true"
import script from "./couponSlide.vue?vue&type=script&lang=js"
export * from "./couponSlide.vue?vue&type=script&lang=js"
import style0 from "./couponSlide.vue?vue&type=style&index=0&id=42f780c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f780c8",
  null
  
)

export default component.exports